import { useContext, useEffect, useState } from 'react';
import { ProductItemsModel, UserProviderValue } from '../models';
import { ProductItemStatuses } from '../enums';
import { UserContext } from '../contexts/user.context';

export const useStoreProducts = (raffles: ProductItemsModel, setRaffles: (raffles: ProductItemsModel) => void) => {
   const { balance } = useContext<UserProviderValue>(UserContext);

   const [selectedRaffleStatus, setSelectedRaffleStatus] = useState<string>(raffles.pagination.status as ProductItemStatuses);

   useEffect(() => {
      if (!raffles.productItems) return;
      setRaffles({
         ...raffles,
         pagination: {
            ...raffles.pagination,
            page: 1,
            status: selectedRaffleStatus as ProductItemStatuses,
         },
      });
   }, [selectedRaffleStatus]);

   const loadMoreRaffles = async () => {
      setRaffles({
         ...raffles,
         pagination: {
            ...raffles.pagination,
            page: raffles.pagination.page + 1,
         },
      });
   };

   return {
      selectedRaffleStatus,
      setSelectedRaffleStatus,
      loadMoreRaffles,
      balance,
   };
};
